module.exports = __webpack_public_path__ + "static/media/over_age_img@2x.b4505ce8.png";